export default "__VITE_ASSET__B13Rp9$K__"